export default "__VITE_ASSET__BsN6NNF0__"